// Style utilities for LocationImage component

export const layeredSxBase = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'opacity 300ms cubic-bezier(.4,0,.2,1), transform 300ms cubic-bezier(.4,0,.2,1)',
};

export const getUploadingSx = (isUploading) => ({
  ...layeredSxBase,
  transition: 'opacity 280ms cubic-bezier(.4,0,.2,1), transform 280ms cubic-bezier(.4,0,.2,1)',
  opacity: isUploading ? 1 : 0,
  transform: isUploading ? 'translateY(0) scale(1)' : 'translateY(-8px) scale(0.9)',
  pointerEvents: isUploading ? 'auto' : 'none',
});

export const getUploadedSx = (isUploaded) => ({
  ...layeredSxBase,
  opacity: isUploaded ? 1 : 0,
  transform: isUploaded ? 'translateY(0) scale(1)' : 'translateY(8px) scale(0.9)',
  pointerEvents: isUploaded ? 'auto' : 'none',
});

export const getNotUploadedSx = (isNotUploaded) => ({
  ...layeredSxBase,
  opacity: isNotUploaded ? 1 : 0,
  transform: isNotUploaded ? 'translateY(0) scale(1)' : 'translateY(8px) scale(0.9)',
  pointerEvents: isNotUploaded ? 'auto' : 'none',
});

export const getIdleSx = (isUploading, isUploaded, isNotUploaded) => {
  const idle = !isUploading && !isUploaded && !isNotUploaded;
  return {
    ...layeredSxBase,
    opacity: idle ? 1 : 0,
    transform: idle ? 'translateY(0) scale(1)' : 'translateY(8px) scale(0.9)',
    pointerEvents: idle ? 'auto' : 'none',
  };
};

// Image container transition (fades & scales in when loaded)
export const getImageContainerSx = (isLoaded) => ({
  position: 'relative',
  // Animate flex-basis so the dropzone is pushed smoothly
  flex: '0 0 auto',
  flexBasis: isLoaded ? '40%' : '0px',
  width: isLoaded ? '40%' : '0px', // keep width in sync for older browsers
  minWidth: isLoaded ? 180 : 0,
  marginRight: isLoaded ? '12px' : 0,
  borderRadius: '6px',
  overflow: 'hidden',
  boxShadow: isLoaded ? '0 2px 4px rgba(0,0,0,0.12)' : 'none',
  background: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  willChange: 'flex-basis, width, margin-right, opacity, transform',
  transition: 'flex-basis 360ms ease, width 360ms ease, min-width 360ms ease, margin-right 300ms ease, opacity 320ms ease, transform 320ms ease, box-shadow 250ms ease',
  opacity: isLoaded ? 1 : 0,
  transform: isLoaded ? 'translateY(0) scale(1)' : 'translateY(6px) scale(.96)',
  '&:hover': {
    boxShadow: '0 12px 30px rgba(0,0,0,0.18)',
    transform: 'translateY(-6px) scale(1.02)',
  },
});

// Image styling (fixed size, contained, rounded corners)
export const getImageSx = () => ({
  width: '100%',
  maxWidth: '100%',
  maxHeight: '100%',
  height: '150px',
  borderRadius: '6px',
  objectFit: 'contain',
  display: 'block',
  cursor: 'pointer'
});

// Dropzone adaptive transition: shifts width depending on image presence (handled by parent layout) and animates subtle entrance
export const getDropzoneSx = (isImageLoaded) => ({
  // Allow the dropzone to take remaining space but shrink without overflowing
  flex: '1 1 0%',
  minWidth: 0,            // critical so flex item can shrink below intrinsic width
  maxWidth: '100%',
  position: 'relative',
  borderRadius: '6px',
  backgroundColor: '#ffffff',
  overflow: 'hidden',      // prevent its internal content from overlapping the upload button
  display: 'flex',
  alignItems: 'stretch',
  transition: 'box-shadow 240ms ease, transform 300ms ease',
  // Ensure inner dropzone wrapper (whatever MDDropzone renders) fits the flex box
  '& > *': {
    flex: 1,
    minWidth: 0,
    maxWidth: '100%',
  },
  '&:hover': {
    boxShadow: '0 12px 30px rgba(0,0,0,0.18)',
    transform: 'translateY(-6px) scale(1.02)',
  },
});

export const getUploadButtonSx = (buttonSize) => ({
   height: buttonSize, 
   position: 'relative', 
   overflow: 'hidden',
  '&:hover': {
    boxShadow: '0 12px 30px rgba(0,0,0,0.18)',
      transform: 'translateY(-6px) scale(1.02)',
  }
})


